export default __webpack_public_path__ + "static/plugins/daypilot/daypilot-all.min.js";